module.exports = __webpack_public_path__ + "media/images/top/package/package-image3-2d25e1eb443b2f97f1814eaed09c4fd1.png";